import type { ComponentType, ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './card';
import { cn } from '@/lib/utils';

export interface SectionCardProps {
  icon?: ComponentType<{ className?: string }>;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  testId?: string;
  className?: string;
  contentClassName?: string;
}

/**
 * Tarjeta de sección estándar (UI-STD-1): fondo `bg-card` (blanco), icono
 * corporativo antes del título, descripción/acciones opcionales.
 */
export function SectionCard({
  icon: Icon,
  title,
  description,
  actions,
  children,
  testId,
  className,
  contentClassName,
}: SectionCardProps) {
  return (
    <Card className={cn('bg-card', className)} data-testid={testId}>
      <CardHeader className="flex flex-row items-start justify-between gap-3 space-y-0 pb-3">
        <div className="flex min-w-0 items-start gap-2">
          {Icon && (
            <Icon
              className="mt-0.5 h-5 w-5 shrink-0 text-primary"
              aria-hidden="true"
            />
          )}
          <div className="min-w-0">
            <CardTitle className="text-base font-semibold">{title}</CardTitle>
            {description && (
              <p className="mt-1 text-sm text-muted-foreground">
                {description}
              </p>
            )}
          </div>
        </div>
        {actions && (
          <div className="flex shrink-0 flex-wrap items-center gap-2">
            {actions}
          </div>
        )}
      </CardHeader>
      <CardContent className={cn('pt-0', contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}
